<template>
  <div class="collapse-wrap">
    <div v-for="(faq, i) in faqs" :key="i" :class="{ 'bd-b-1 bd-gray-medium': i == faqs.length - 1 }">
      <h3 class="collapse-title" @click="toggle(faq.id)">
        <img src="https://s3-cdn.designerjourneys.com/static/icons/icon-chevron.svg" :class="{ active: opened.includes(faq.id) }" alt="accordion" />
        <div :class="{ active: opened.includes(faq.id) }">{{ faq.title }}</div>
      </h3>
      <div class='collapse-content' :class='{ active: opened.includes(faq.id) }'>
        <div v-html='faq.text' class='lh-24'></div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { ref } from "vue"

export default {
  name: "Collapse",
  props: {
    faqs: {
      type: Array,
      default: null,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const opened = ref([])
    const toggle = (id) => {
      const index = opened.value.indexOf(id)
      if (index > -1) {
        opened.value.splice(index, 1)
      } else {
        opened.value.push(id)
      }
    }
    watch(
      () => props.expandAll,
      (value) => {
        opened.value = value ? props.faqs.map((faq) => faq.id) : []
      },
    )
    if (props.expandAll) {
      opened.value = props.faqs.map((faq) => faq.id)
    }

    return {
      toggle,
      opened,
    }
  },
}
</script>
<style lang='scss'>
.list-ans {
  list-style: disc;
  padding-left: 15px;
  li {
    margin-bottom: 10px;
  }
}
.collapse-wrap {
  max-width: 820px;
  width: 100%;

  img {
    width: 12px;
    height: 6px;

    &.active {
      transform: rotate(-90deg);
      transition: 0.3 all linear;
    }
  }

  .collapse-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-top: 1px solid $gray-medium;

    div {
      width: 100%;
      display: block;
      padding: 30px 0;
      color: $black;
      font-family: $font-family-proximanova-black;
      font-weight: 900;
      font-size: 18px;
      line-height: 18px;
      margin-left: 20px;

      &:hover {
        text-decoration: none;
      }

      &.active {
        background-color: transparent;
        color: $black;
      }
    }
  }

  .collapse-content {
    padding: 0 30px;
    height: 0;
    transition: all 0.5s ease;
    overflow: hidden;
    opacity: 0;
    font-size: 16px;
    line-height: 24px;

    &.active {
      height: auto;
      padding-bottom: 30px;
      opacity: 1;
    }
  }
}
</style>
